import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import api from '../../libs/axios';
import Breadcrumb from '../../utils/breadcrumbs';
import { ListLoader } from '../../utils/loader';

interface DeletedUser { id: number; phone_number: string | null; deleted_at: string | null; updated_at: string | null; }

const fmt = (d: string | null) => (d ? new Date(d).toLocaleString() : '-');

const DeletedAccounts: React.FC = () => {
  const [users, setUsers] = useState<DeletedUser[]>([]);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const res: any = await api.get('/users/deleted');
      setUsers(res.data || []);
    } catch (e) {
      toast.error('Failed to load deleted accounts');
    } finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  return (
    <div className="p-4 sm:p-6">
      <Breadcrumb />
      <div className="mt-4 mb-6">
        <h1 className="text-xl font-semibold text-gray-900">Deleted Accounts</h1>
        <p className="text-sm text-gray-500">Permanently deleted (tombstoned) accounts. Personal data is anonymized; match history is kept as "Deleted User".</p>
      </div>

      {loading ? <ListLoader /> : (
        <div className="bg-white border border-gray-200 rounded-xl overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-gray-50 text-gray-600">
                <tr>
                  <th className="text-left font-medium px-4 py-3">User ID</th>
                  <th className="text-left font-medium px-4 py-3">Phone (freed)</th>
                  <th className="text-left font-medium px-4 py-3">Deleted at</th>
                </tr>
              </thead>
              <tbody>
                {users.length === 0 ? (
                  <tr><td colSpan={3} className="px-4 py-8 text-center text-gray-400">No deleted accounts</td></tr>
                ) : users.map((u) => (
                  <tr key={u.id} className="border-t border-gray-100">
                    <td className="px-4 py-3 text-gray-900">#{u.id}</td>
                    <td className="px-4 py-3 text-gray-600">{u.phone_number || '-'}</td>
                    <td className="px-4 py-3 text-gray-600">{fmt(u.deleted_at)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default DeletedAccounts;
